import React from "react";
import { DateTime } from "luxon";
import styled from "styled-components";

import Countdown from "../Countdown/Countdown";

export const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #222;
  background-color: #d6c8ac;
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;

  @media (max-width: 1023px) {
    height: 40px;
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    height: 46px;
    font-size: 20px;
  }

  span {
    margin-top: 4px;
  }

  svg {
    position: relative;
    top: -1px;
    margin: 0 10px;
  }
`;

const CountdownHeader = () => {
  return (
    <Root>
      <Countdown
        variant="secondary"
        expires={
          DateTime.now() <
          DateTime.fromObject(
            {
              year: 2023,
              month: 11,
              day: 30,
              hour: 0,
              minute: 0,
              second: 0,
            },
            { zone: "America/New_York" },
          )
            ? {
                // year: 2023,
                // month: 11,
                // day: 2,
                // hour: 0,
                // minute: 0,
                // second: 0,
                year: 2023,
                month: 11,
                day: 30,
                hour: 23,
                minute: 59,
                second: 59,
              }
            : {
                year: 2023,
                month: 11,
                day: 30,
                hour: 23,
                minute: 59,
                second: 59,
              }
        }
        timezone="America/New_York"
      />
    </Root>
  );
};

export default CountdownHeader;
